module.exports = __webpack_public_path__ + "static/media/weekly_progress_empty_state.030e3a6a.svg";